<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{ toggleMenu }">
              <button
                tabindex="-1"
                @click="toggleMenu"
                class="btn-filter-operator"
              >
                <div :class="['icon24', nativeFilterIconClass]"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox-enum
        v-model="filterValue"
        ref="thEnum"
        :enum="col.enum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :values="col.filterValue"
        @selected="
          ({ newData }) => {
            filterHeaderHandleEnum(newData, { operator: operatorValue, value: filterValue });
          }
        "
        :hasBorder="false"
      ></ms-combobox-enum>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default defineComponent({
  extends: msThOptionBase,
  components: { msValidate, MenuItem, MenuWrapper },
  name: 'MsThOptionEnum',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
  },
  setup(props, { emit }) {
    //Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandleEnum,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
    } = setup(props, {
      emit,
    });
    //Method
    //Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandleEnum,
      removeFilter,
      thEnum,
    };
  },
});
</script>
